import {
  generateContentByPromptObject as publicGenerateContentByPromptObject,
  generateTextByPromptObjectStreamed as publicGenerateTextByPromptObjectStreamed,
  generateContentByPromptObjectAsync as publicGenerateContentByPromptObjectAsync,
  generateAudioStreamed as publicGenerateAudioStreamed,
} from './api-infra-v1-prompt-proxy-prompts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onPromptProxyCompleted as publicOnPromptProxyCompleted } from './api-infra-v1-prompt-proxy-prompts.public.js';

/** @internal */
export const generateContentByPromptObject: MaybeContext<
  BuildRESTFunction<typeof publicGenerateContentByPromptObject> &
    typeof publicGenerateContentByPromptObject
> = /*#__PURE__*/ createRESTModule(publicGenerateContentByPromptObject);
/** @internal */
export const generateTextByPromptObjectStreamed: MaybeContext<
  BuildRESTFunction<typeof publicGenerateTextByPromptObjectStreamed> &
    typeof publicGenerateTextByPromptObjectStreamed
> = /*#__PURE__*/ createRESTModule(publicGenerateTextByPromptObjectStreamed);
/** @internal */
export const generateContentByPromptObjectAsync: MaybeContext<
  BuildRESTFunction<typeof publicGenerateContentByPromptObjectAsync> &
    typeof publicGenerateContentByPromptObjectAsync
> = /*#__PURE__*/ createRESTModule(publicGenerateContentByPromptObjectAsync);
/** @internal */
export const generateAudioStreamed: MaybeContext<
  BuildRESTFunction<typeof publicGenerateAudioStreamed> &
    typeof publicGenerateAudioStreamed
> = /*#__PURE__*/ createRESTModule(publicGenerateAudioStreamed);
/** */
export const onPromptProxyCompleted: BuildEventDefinition<
  typeof publicOnPromptProxyCompleted
> &
  typeof publicOnPromptProxyCompleted = createEventModule(
  publicOnPromptProxyCompleted
);

export {
  OpenaiproxyV1ChatCompletionMessageMessageRole,
  OpenaiproxyV1Model,
  ChatCompletionMessageMessageRole,
  V1Model,
  Language,
  Outcome,
  FinishReason,
  HarmCategory,
  HarmProbability,
  Modality,
  ResponseTypeType,
  Role,
  Type,
  MediaType,
  GoogleproxyV1ResponseTypeType,
  V1MessageRoleRole,
  V1CacheControlType,
  V1ImageMediaTypeMediaType,
  V1ResponseTypeType,
  MessageRoleRole,
  CacheControlType,
  ImageMediaTypeMediaType,
  PerplexityMessageMessageRole,
  PerplexityModel,
  V1ImageModel,
  ImageModel,
  ImageCoreModel,
  ImageStableDiffusionModel,
  EditImageWithPromptRequestModel,
  OpenAiImageModel,
  V1ChatCompletionMessageMessageRole,
  ChatCompletionModel,
  MessageRole,
  V1ResponsesModel,
  ResponsesModel,
  Fireworks_proxyV1ChatCompletionMessageMessageRole,
  GoogleproxyV1Model,
  ContentRole,
  MediaResolutionLevel,
  DynamicRetrievalConfigMode,
  Environment,
  Threshold,
  PersonGeneration,
  Mode,
  Model,
  ToolChoiceType,
  McpServerType,
  ClaudeModel,
  GoogleproxyV1ToolChoiceType,
  GoogleproxyV1McpServerType,
  AnthropicModel,
  V1ToolChoiceType,
  V1McpServerType,
  LlamaModel,
  ConverseModel,
  ImageQuality,
  ImageSize,
  ImageStyle,
  ClipGuidancePreset,
  Sampler,
  TextToImageRequestStylePreset,
  GenerateCoreRequestStylePreset,
  GenerationMode,
  GenerateStableDiffusionRequestOutputFormat,
  GenerateAnImageModel,
  CreatePredictionModel,
  TaskInput,
  ResponseType,
  StylePreset,
  TextToImageRequestModel,
  ImagenModel,
  GenerateImageMlPlatformModel,
  VideoGenModel,
  OutputFormat,
  VideoModel,
  ResponsesInputMessageResponsesMessageRole,
  ResponsesMessageRole,
  V1VideoModel,
  GatewayMessageDefinitionRole,
  SpeechModel,
  ElevenLabsTextToSpeechModel,
  WebhookIdentityType,
} from './api-infra-v1-prompt-proxy-prompts.universal.js';
export {
  PromptProxy,
  GenerationCompletedResultEvent,
  GenerateContentModelResponse,
  GenerateContentModelResponseResponseOneOf,
  GeneratedContent,
  TextContent,
  MediaContent,
  ThinkingTextContent,
  ToolUseContent,
  V1TokenUsage,
  ResponseMetadata,
  OpenaiproxyV1CreateChatCompletionResponse,
  OpenaiproxyV1ChatCompletionMessage,
  V1ChatCompletionMessageFunctionWithArgs,
  OpenaiproxyV1ChatCompletionMessageImageUrlContent,
  V1ChatCompletionMessageToolCall,
  OpenaiproxyV1ChatCompletionMessageContentPart,
  OpenaiproxyV1ChatCompletionMessageContentPartContentValueOneOf,
  CreateChatCompletionResponsePromptTokenDetails,
  CreateChatCompletionResponseCompletionTokenDetails,
  OpenaiproxyV1CreateChatCompletionResponseChoice,
  OpenaiproxyV1CreateChatCompletionResponseTokenUsage,
  CreateChatCompletionResponse,
  V1ChatCompletionMessage,
  FunctionWithArgs,
  ChatCompletionMessageImageUrlContent,
  ToolCall,
  ChatCompletionMessageContentPart,
  ChatCompletionMessageContentPartContentValueOneOf,
  PromptTokenDetails,
  CompletionTokenDetails,
  CreateChatCompletionResponseChoice,
  CreateChatCompletionResponseTokenUsage,
  GenerateContentResponse,
  Candidate,
  CandidateContent,
  FunctionCall,
  ExecutableCode,
  V1CodeExecutionResult,
  Blob,
  CandidateContentPart,
  SafetyRating,
  CandidateCitationMetadata,
  PublicationDate,
  CandidateCitationMetadataCitation,
  GroundingMetadata,
  SearchEntryPoint,
  GroundingChunk,
  GroundingChunkChunkTypeOneOf,
  Web,
  RetrievedContext,
  GroundingSupport,
  Segment,
  RetrievalMetadata,
  UsageMetadata,
  ModalityTokenCount,
  InvokeAnthropicClaudeModelResponse,
  Usage,
  ContentBlock,
  ContentBlockTypeOneOf,
  Text,
  CacheControl,
  V1ImageUrl,
  ToolUse,
  ToolResult,
  SimpleContentBlock,
  SimpleContentBlockTypeOneOf,
  Thinking,
  RedactedThinking,
  V1InvokeAnthropicClaudeModelResponse,
  GoogleproxyV1Usage,
  GoogleproxyV1ContentBlock,
  GoogleproxyV1ContentBlockTypeOneOf,
  GoogleproxyV1Text,
  GoogleproxyV1CacheControl,
  GoogleproxyV1ImageUrl,
  GoogleproxyV1ToolUse,
  GoogleproxyV1ToolResult,
  V1SimpleContentBlock,
  V1SimpleContentBlockTypeOneOf,
  GoogleproxyV1Thinking,
  GoogleproxyV1RedactedThinking,
  InvokeAnthropicModelResponse,
  V1Usage,
  UsageCacheCreation,
  UsageServerToolUse,
  Container,
  V1ContentBlock,
  V1ContentBlockTypeOneOf,
  V1Text,
  V1CacheControl,
  Citation,
  CitationTypeOneOf,
  CharLocationCitation,
  PageLocationCitation,
  ContentBlockLocationCitation,
  WebSearchResultLocationCitation,
  SearchResultLocationCitation,
  AnthropicV1ImageUrl,
  V1ToolUse,
  V1ToolResult,
  ToolResultContentBlock,
  ToolResultContentBlockTypeOneOf,
  DocumentContent,
  DocumentSource,
  CitationsEnabled,
  ToolResultSearchResult,
  V1Thinking,
  V1RedactedThinking,
  McpToolUse,
  ServerToolUse,
  WebSearchToolResult,
  WebSearchToolResultContentOneOf,
  WebSearchResultList,
  WebSearchResult,
  WebSearchToolResultError,
  CodeExecutionToolResult,
  CodeExecutionToolResultContentOneOf,
  CodeExecutionResult,
  CodeExecutionToolResultError,
  ContainerUpload,
  WebFetchToolResult,
  WebFetchToolResultContentOneOf,
  WebFetchToolResultContentSuccess,
  WebFetchToolResultContentError,
  InvokeLlamaModelResponse,
  InvokeConverseResponse,
  ConverseMessage,
  ConverseContentBlock,
  ConverseContentBlockContentOneOf,
  ConverseReasoningContent,
  ReasoningText,
  ConverseToolUse,
  ConverseToolResult,
  ConverseToolResultContent,
  ConverseToolResultContentContentOneOf,
  Output,
  InvokeConverseResponseTokenUsage,
  Metrics,
  ConversePerformanceConfig,
  InvokeMlPlatformLlamaModelResponse,
  InvokeChatCompletionResponse,
  PerplexityMessage,
  InvokeChatCompletionResponseChoice,
  PerplexityImageDescriptor,
  InvokeChatCompletionResponseUsage,
  CreateImageResponse,
  V1ImageObject,
  V1TextToImageResponse,
  ImageObject,
  GenerateCoreResponse,
  GenerateStableDiffusionResponse,
  GenerateAnImageResponse,
  ResultObject,
  CreatePredictionResponse,
  CreatePredictionResponseTokenUsage,
  EditImageWithPromptResponse,
  TextToImageResponse,
  TextToImageTaskResult,
  V1GenerateImageResponse,
  Prediction,
  SafetyAttributes,
  GenerateVideoResponse,
  GeneratedVideo,
  GenerateImageMlPlatformResponse,
  CreateImageOpenAiResponse,
  V1ImageUsage,
  OpenAiImageTokenDetails,
  EditImageOpenAiResponse,
  V1CreateChatCompletionResponse,
  GoogleproxyV1ChatCompletionMessage,
  V1ChatCompletionMessageImageUrlContent,
  V1ChatCompletionMessageContentPart,
  V1ChatCompletionMessageContentPartContentValueOneOf,
  V1CreateChatCompletionResponseChoice,
  V1CreateChatCompletionResponseTokenUsage,
  InvokeMlPlatformOpenAIChatCompletionRawResponse,
  ChatCompletionMessage,
  ImageUrlContent,
  ContentPart,
  ContentPartContentValueOneOf,
  Choice,
  TokenUsage,
  VideoInferenceResponse,
  VideoInferenceTaskResult,
  V1OpenAiResponsesResponse,
  OpenAiResponsesResponseIncompleteDetails,
  V1ResponsesOutput,
  V1ResponsesOutputOutputOneOf,
  V1ResponsesOutputMessage,
  V1OutputAnnotation,
  V1OutputAnnotationAnnotationTypeOneOf,
  V1UrlCitation,
  ResponsesOutputMessageOutputContent,
  V1ResponsesWebSearchToolCall,
  ResponsesWebSearchToolCallAction,
  V1ResponsesFunctionToolCall,
  V1ResponsesReasoningOutput,
  V1ResponsesReasoningSummaryContent,
  V1ResponsesReasoningContent,
  V1ResponsesCodeInterpreterToolCall,
  V1ResponsesCodeInterpreterOutput,
  V1ResponsesCodeInterpreterOutputOutputTypeOneOf,
  V1ResponsesCodeInterpreterLogsOutput,
  V1ResponsesCodeInterpreterImageOutput,
  V1ResponsesReasoning,
  V1ResponsesTokenUsage,
  V1ResponsesInputTokensDetails,
  V1ResponsesOutputTokensDetails,
  OpenAiResponsesResponse,
  IncompleteDetails,
  ResponsesOutput,
  ResponsesOutputOutputOneOf,
  ResponsesOutputMessage,
  OutputAnnotation,
  OutputAnnotationAnnotationTypeOneOf,
  UrlCitation,
  OutputContent,
  ResponsesWebSearchToolCall,
  Action,
  ResponsesFunctionToolCall,
  ResponsesReasoningOutput,
  ResponsesReasoningSummaryContent,
  ResponsesReasoningContent,
  ResponsesCodeInterpreterToolCall,
  ResponsesCodeInterpreterOutput,
  ResponsesCodeInterpreterOutputOutputTypeOneOf,
  ResponsesCodeInterpreterLogsOutput,
  ResponsesCodeInterpreterImageOutput,
  ResponsesReasoning,
  ResponsesTokenUsage,
  ResponsesInputTokensDetails,
  ResponsesOutputTokensDetails,
  CreateVideoResponse,
  VideoJob,
  ErrorInfo,
  InvokeCustomOpenAiModelResponse,
  Fireworks_proxyV1ChatCompletionMessage,
  ChatCompletionMessageFunctionWithArgs,
  Fireworks_proxyV1ChatCompletionMessageImageUrlContent,
  ChatCompletionMessageToolCall,
  Fireworks_proxyV1ChatCompletionMessageContentPart,
  Fireworks_proxyV1ChatCompletionMessageContentPartContentValueOneOf,
  InvokeCustomOpenAiModelResponsePromptTokenDetails,
  InvokeCustomOpenAiModelResponseCompletionTokenDetails,
  InvokeCustomOpenAiModelResponseChoice,
  InvokeCustomOpenAiModelResponseTokenUsage,
  CreateContentTaskResponse,
  CommonContentTaskResponse,
  TaskError,
  TaskContent,
  TaskUsage,
  GenerateImageResponse,
  ImageData,
  ImageError,
  ImageUsage,
  GenerateContentByPromptObjectRequest,
  Prompt,
  PromptModelRequestOneOf,
  FallbackPromptConfig,
  OpenaiproxyV1CreateChatCompletionRequest,
  OpenaiproxyV1CreateChatCompletionRequestFunctionCallOneOf,
  CreateChatCompletionRequestFunctionSignature,
  V1CreateChatCompletionRequestTool,
  V1FineTuningSpec,
  OpenaiproxyV1CreateChatCompletionRequestResponseFormat,
  CreateChatCompletionRequest,
  CreateChatCompletionRequestFunctionCallOneOf,
  FunctionSignature,
  CreateChatCompletionRequestTool,
  CreateChatCompletionRequestResponseFormat,
  GenerateContentRequest,
  Content,
  V1ContentPart,
  ContentData,
  FunctionResponse,
  FunctionResponsePart,
  FunctionResponsePartDataOneOf,
  FunctionResponseBlob,
  MediaResolution,
  SystemInstruction,
  GoogleproxyV1Tool,
  DynamicRetrievalConfig,
  FunctionDeclaration,
  GoogleSearchRetrieval,
  CodeExecution,
  GoogleSearch,
  ComputerUse,
  SafetySetting,
  GenerationConfig,
  GenerationThinkingConfig,
  ImageConfig,
  ImageOutputOptions,
  V1ToolConfig,
  FunctionCallingConfig,
  FineTuningSpec,
  InvokeAnthropicClaudeModelRequest,
  InputSchema,
  AnthropicClaudeMessage,
  Tool,
  ToolChoice,
  ThinkingConfig,
  McpServer,
  ToolConfiguration,
  V1InvokeAnthropicClaudeModelRequest,
  GoogleproxyV1InputSchema,
  V1AnthropicClaudeMessage,
  InvokeAnthropicClaudeModelRequestTool,
  GoogleproxyV1ToolChoice,
  GoogleproxyV1ThinkingConfig,
  GoogleproxyV1McpServer,
  V1McpServerToolConfiguration,
  InvokeAnthropicModelRequest,
  AnthropicMessage,
  V1Tool,
  V1ToolKindOneOf,
  CustomTool,
  V1InputSchema,
  ComputerUseTool,
  TextEditorTool,
  BashTool,
  WebSearchTool,
  WebSearchUserLocation,
  CodeExecutionTool,
  WebFetchTool,
  V1ToolChoice,
  V1ThinkingConfig,
  V1McpServer,
  McpServerToolConfiguration,
  RequestMetadata,
  InvokeLlamaModelRequest,
  InvokeConverseRequest,
  ConverseInferenceConfig,
  ToolConfig,
  ConverseTool,
  ToolSpecification,
  ConverseInputSchema,
  SystemContentBlock,
  CreateImageRequest,
  V1TextToImageRequest,
  TextPrompt,
  GenerateCoreRequest,
  GenerateStableDiffusionRequest,
  GenerateAnImageRequest,
  CreatePredictionRequest,
  CreatePredictionRequestInputOneOf,
  FluxPulid,
  FluxDevControlnet,
  ReveEdit,
  LucatacoFlorence2Large,
  PerceptronIsaac01,
  PrunaaiZImageTurbo,
  QwenImageLayered,
  EditImageWithPromptRequest,
  OutpaintDirection,
  TextToImageRequest,
  LoraModelSelect,
  Inputs,
  InvokeMlPlatformLlamaModelRequest,
  InvokeChatCompletionRequest,
  InvokeChatCompletionRequestResponseFormat,
  InvokeChatCompletionRequestResponseFormatFormatDetailsOneOf,
  V1GenerateImageRequest,
  Instance,
  Parameters,
  OutputOptions,
  GenerateImageMlPlatformRequest,
  GenerateImageMlPlatformRequestInputOneOf,
  V1FluxPulid,
  CreateImageOpenAiRequest,
  EditImageOpenAiRequest,
  GenerateVideoRequest,
  GenerateVideoInstance,
  V1ImageInput,
  GenerateVideoParameters,
  V1CreateChatCompletionRequest,
  V1CreateChatCompletionRequestResponseFormat,
  InvokeMlPlatformOpenAIChatCompletionRawRequest,
  ResponseFormat,
  VideoInferenceRequest,
  FrameImage,
  VideoInputs,
  V1OpenAiResponsesRequest,
  V1ResponsesInputItem,
  V1ResponsesInputItemItemOneOf,
  V1ResponsesInputMessage,
  V1ResponsesInputMessageContent,
  V1ResponsesInputMessageContentContentValueOneOf,
  ResponsesInputMessageContentImageInput,
  ResponsesInputMessageContentFileInput,
  V1ResponsesFunctionToolCallOutput,
  V1ResponsesTextFormat,
  V1ResponsesTextFormatFormatOneOf,
  ResponsesTextFormatJsonSchema,
  V1ResponsesToolChoice,
  V1ResponsesTool,
  V1ResponsesToolToolTypeOneOf,
  V1ResponsesWebSearch,
  ResponsesWebSearchUserLocation,
  V1ResponsesFunction,
  V1ResponsesCodeInterpreter,
  V1ResponsesCodeInterpreterContainer,
  V1ResponsesCodeInterpreterContainerContainerTypeOneOf,
  V1ResponsesCodeInterpreterContainerAuto,
  OpenAiResponsesRequest,
  ResponsesInputItem,
  ResponsesInputItemItemOneOf,
  ResponsesInputMessage,
  ResponsesInputMessageContent,
  ResponsesInputMessageContentContentValueOneOf,
  ImageInput,
  FileInput,
  ResponsesFunctionToolCallOutput,
  ResponsesTextFormat,
  ResponsesTextFormatFormatOneOf,
  JsonSchema,
  ResponsesToolChoice,
  ResponsesTool,
  ResponsesToolToolTypeOneOf,
  ResponsesWebSearch,
  UserLocation,
  ResponsesFunction,
  ResponsesCodeInterpreter,
  ResponsesCodeInterpreterContainer,
  ResponsesCodeInterpreterContainerContainerTypeOneOf,
  ResponsesCodeInterpreterContainerAuto,
  CreateVideoRequest,
  InvokeCustomOpenAiModelRequest,
  InvokeCustomOpenAiModelRequestFunctionCallOneOf,
  InvokeCustomOpenAiModelRequestFunctionSignature,
  InvokeCustomOpenAiModelRequestTool,
  InvokeCustomOpenAiModelRequestResponseFormat,
  CreateContentTaskRequest,
  ContentItem,
  ImageUrl,
  DraftTask,
  GenerateImageRequest,
  SequentialImageGenerationOptions,
  OptimizePromptOptions,
  UserRequestInfo,
  FallbackProperties,
  AsyncGenerationConfig,
  SpiGenerationConfig,
  DynamicRequestConfig,
  GatewayToolDefinition,
  GatewayToolDefinitionToolOneOf,
  GatewayToolDefinitionCustomTool,
  BuiltInTool,
  GatewayMessageDefinition,
  GatewayContentBlock,
  GatewayContentBlockTypeOneOf,
  ToolResultContent,
  GenerateContentByPromptObjectResponse,
  GenerateTextByPromptObjectRequest,
  GeneratedTextChunk,
  GeneratedTextChunkModelChunkOneOf,
  ChatCompletionChunk,
  ChunkDelta,
  ChunkChoice,
  OpenaiproxyV1ChatCompletionChunk,
  ChatCompletionChunkChunkChoiceChunkDelta,
  V1ChatCompletionChunkChunkChoice,
  GoogleproxyV1AnthropicStreamChunk,
  GoogleproxyV1AnthropicStreamChunkContentOneOf,
  GoogleproxyV1ContentBlockDelta,
  GoogleproxyV1ContentBlockDeltaDeltaOneOf,
  V1AnthropicStreamChunkMessageDelta,
  AnthropicStreamChunk,
  AnthropicStreamChunkContentOneOf,
  ContentBlockDelta,
  ContentBlockDeltaDeltaOneOf,
  MessageDelta,
  V1AnthropicStreamChunk,
  V1AnthropicStreamChunkContentOneOf,
  V1ContentBlockDelta,
  V1ContentBlockDeltaDeltaOneOf,
  AnthropicStreamChunkMessageDelta,
  V1ChatCompletionChunk,
  ChunkChoiceChunkDelta,
  ChatCompletionChunkChunkChoice,
  GenerateAudioRequest,
  GenerateAudioRequestAudioRequestOneOf,
  CreateSpeechRequest,
  TextToSpeechRequest,
  VoiceSettings,
  PronunciationDictionaryLocator,
  GeneratedAudioChunk,
  GeneratedAudioChunkAudioChunkOneOf,
  SpeechChunk,
  TextToSpeechChunk,
  AlignmentInfoInChunk,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  PromptProxyCompletedEnvelope,
  GenerateContentByPromptObjectOptions,
  GenerateTextByPromptObjectStreamedOptions,
  GenerateContentByPromptObjectAsyncOptions,
  GenerateAudioStreamedOptions,
  GenerateAudioStreamedOptionsAudioRequestOneOf,
} from './api-infra-v1-prompt-proxy-prompts.universal.js';
export {
  OpenaiproxyV1ChatCompletionMessageMessageRoleWithLiterals,
  OpenaiproxyV1ModelWithLiterals,
  ChatCompletionMessageMessageRoleWithLiterals,
  V1ModelWithLiterals,
  LanguageWithLiterals,
  OutcomeWithLiterals,
  FinishReasonWithLiterals,
  HarmCategoryWithLiterals,
  HarmProbabilityWithLiterals,
  ModalityWithLiterals,
  ResponseTypeTypeWithLiterals,
  RoleWithLiterals,
  TypeWithLiterals,
  MediaTypeWithLiterals,
  GoogleproxyV1ResponseTypeTypeWithLiterals,
  V1MessageRoleRoleWithLiterals,
  V1CacheControlTypeWithLiterals,
  V1ImageMediaTypeMediaTypeWithLiterals,
  V1ResponseTypeTypeWithLiterals,
  MessageRoleRoleWithLiterals,
  CacheControlTypeWithLiterals,
  ImageMediaTypeMediaTypeWithLiterals,
  PerplexityMessageMessageRoleWithLiterals,
  PerplexityModelWithLiterals,
  V1ImageModelWithLiterals,
  ImageModelWithLiterals,
  ImageCoreModelWithLiterals,
  ImageStableDiffusionModelWithLiterals,
  EditImageWithPromptRequestModelWithLiterals,
  OpenAiImageModelWithLiterals,
  V1ChatCompletionMessageMessageRoleWithLiterals,
  ChatCompletionModelWithLiterals,
  MessageRoleWithLiterals,
  V1ResponsesModelWithLiterals,
  ResponsesModelWithLiterals,
  Fireworks_proxyV1ChatCompletionMessageMessageRoleWithLiterals,
  GoogleproxyV1ModelWithLiterals,
  ContentRoleWithLiterals,
  MediaResolutionLevelWithLiterals,
  DynamicRetrievalConfigModeWithLiterals,
  EnvironmentWithLiterals,
  ThresholdWithLiterals,
  PersonGenerationWithLiterals,
  ModeWithLiterals,
  ModelWithLiterals,
  ToolChoiceTypeWithLiterals,
  McpServerTypeWithLiterals,
  ClaudeModelWithLiterals,
  GoogleproxyV1ToolChoiceTypeWithLiterals,
  GoogleproxyV1McpServerTypeWithLiterals,
  AnthropicModelWithLiterals,
  V1ToolChoiceTypeWithLiterals,
  V1McpServerTypeWithLiterals,
  LlamaModelWithLiterals,
  ConverseModelWithLiterals,
  ImageQualityWithLiterals,
  ImageSizeWithLiterals,
  ImageStyleWithLiterals,
  ClipGuidancePresetWithLiterals,
  SamplerWithLiterals,
  TextToImageRequestStylePresetWithLiterals,
  GenerateCoreRequestStylePresetWithLiterals,
  GenerationModeWithLiterals,
  GenerateStableDiffusionRequestOutputFormatWithLiterals,
  GenerateAnImageModelWithLiterals,
  CreatePredictionModelWithLiterals,
  TaskInputWithLiterals,
  ResponseTypeWithLiterals,
  StylePresetWithLiterals,
  TextToImageRequestModelWithLiterals,
  ImagenModelWithLiterals,
  GenerateImageMlPlatformModelWithLiterals,
  VideoGenModelWithLiterals,
  OutputFormatWithLiterals,
  VideoModelWithLiterals,
  ResponsesInputMessageResponsesMessageRoleWithLiterals,
  ResponsesMessageRoleWithLiterals,
  V1VideoModelWithLiterals,
  GatewayMessageDefinitionRoleWithLiterals,
  SpeechModelWithLiterals,
  ElevenLabsTextToSpeechModelWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './api-infra-v1-prompt-proxy-prompts.universal.js';
